import { createApp } from 'vue';
import vueApp from './vue.vue';
const app = createApp(vueApp);

import quasarLoader from './quasar';
import components from './components';
import router from '../3routes/0index';
import store from '../4services';

quasarLoader({ app });
app.use(components);
app.use(router);
app.use(store);

console.log('✌️ 2loaders.vue.js loaded');

export default () => {
  return app;
};
